export default function AboutSectionFr() {
  const pillars = [
    {
      icon: "ri-global-line",
      title: "Portée mondiale impartiale",
      desc: "Nous exploitons un réseau neutre et étendu de fabricants et de partenaires en Europe, en Chine et en Inde pour mettre les meilleures ressources mondiales au service de nos clients.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Autorité réglementaire",
      desc: "Nous assurons une conformité absolue avec les mandats les plus stricts tels ceux aux États-Unis, en Europe et au Canada (FDA, EMA et Santé Canada).",
    },
    {
      icon: "ri-database-2-line",
      title: "Transparence fondée sur les données",
      desc: "Chaque mandat est soutenu par un « fil numérique » de documentation complète et de traçabilité de bout en bout, garantissant la préparation aux audits dans les marchés réglementés et alimentaires.",
    },
    {
      icon: "ri-settings-3-line",
      title: "Solutions évolutives",
      desc: "De l'approvisionnement standard à la production personnalisée à grande échelle, nous offrons des options réalistes et viables sous stricte confidentialité.",
    },
    {
      icon: "ri-translate-2",
      title: "Bilingue — FR & EN",
      desc: "Nous servons nos clients entièrement en français et en anglais, assurant une communication fluide au Canada, en Europe et sur tous les marchés internationaux.",
    },
  ];

  return (
    <section className="w-full bg-white py-20 px-6 md:px-16">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-16 items-start">
        <div className="lg:w-2/5">
          <span className="text-emerald-600 text-xs font-bold uppercase tracking-widest">
            Qui nous sommes
          </span>
          <h2
            className="text-4xl md:text-5xl font-extrabold text-stone-800 mt-4 leading-tight"
            style={{ fontFamily: "'DM Serif Display', serif" }}
          >
            Approvisionnement mondial,
            <br />
            <span className="text-emerald-600">Notre expertise</span>
          </h2>
          <div className="w-16 h-1 bg-emerald-600 mt-6 mb-8 rounded-full" />
          <p
            className="text-lg font-semibold text-stone-700 leading-snug"
            style={{ fontFamily: "'DM Serif Display', serif" }}
          >
            Approvisionnement stratégique. Conformité mondiale. Précision technique.
          </p>
        </div>

        <div className="lg:w-3/5 flex flex-col gap-6 text-gray-600 text-base leading-relaxed">
          <p>
            Dans une ère de complexité commerciale croissante, de données fragmentées et de contrôle réglementaire rigoureux, la fonction d&apos;approvisionnement est devenue un moteur essentiel de la rentabilité. Chez <strong className="text-emerald-700">MAX-Sourcing</strong>, en partenariat avec vos équipes internes (Achats, AQ, Production), nous comblons le fossé entre les pressions de la chaîne d&apos;approvisionnement mondiale et la recherche de l&apos;excellence opérationnelle.
          </p>
          <p>
            Nous nous spécialisons dans l&apos;identification, la qualification et la gestion de sources éprouvées et collaboratives pour des produits de haute qualité, des matières premières et des services de développement spécialisés. Notre expertise couvre l&apos;ensemble du cycle d&apos;approvisionnement — de la consolidation des dépenses et de l&apos;analyse comparative transfrontalière à la négociation de contrats et à la rédaction d&apos;Accords de Qualité (AQ).
          </p>

          <div className="mt-2">
            <p className="text-stone-800 font-semibold text-sm uppercase tracking-widest mb-5">
              Pourquoi les leaders mondiaux s&apos;associent à MAX-Sourcing
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5">
              {pillars.map((p) => (
                <div
                  key={p.title}
                  className="flex gap-4 items-start bg-stone-50 rounded-lg p-4 border border-stone-100"
                >
                  <div className="w-9 h-9 flex items-center justify-center rounded-md bg-emerald-50 text-emerald-600 shrink-0">
                    <i className={`${p.icon} text-lg`} />
                  </div>
                  <div>
                    <p className="text-stone-800 font-semibold text-sm mb-1">{p.title}</p>
                    <p className="text-gray-500 text-sm leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <p className="text-stone-700 italic border-l-4 border-emerald-500 pl-5 mt-2">
            Chez <strong className="text-emerald-700 not-italic">MAX-Sourcing</strong>, nous ne trouvons pas seulement des fournisseurs ; nous construisons les relations partenaires résilientes et à haute valeur ajoutée qui propulsent le succès des entreprises modernes.
          </p>
        </div>
      </div>
    </section>
  );
}
